import type { TFunction } from 'i18next'

// Shapes from app/OAuthModule/ApiModule/Controllers in the backend. Replace with
// @invo.space/shared schema types after the OpenAPI is generated again.

export type OAuthClient = {
  id: string
  name: string
  clientId: string
  redirectUris: string[]
  scopes: string[]
  serverToServer: boolean
  createdAt: string
}

export type OAuthClientCreated = OAuthClient & {
  clientSecret: string
}

export type OAuthAuthorization = {
  client: { id: string; name: string }
  account: { id: string; name: string }
  scopes: string[]
  authorizedAt: string
}

export type OAuthConsentRequest = {
  client: { id: string; name: string }
  redirectUri: string
  scopes: string[]
  accounts: { id: string; name: string }[]
}

/** 400 from the consent endpoints. With redirectUri, the error goes back to the client app. */
export type OAuthConsentError = {
  error: string
  error_description: string
  redirectUri: string | null
}

export type OAuthServerMetadata = {
  scopes_supported: string[]
}

/** "invoices:read" → "Faktury – čtení". An unknown area shows the raw scope. */
export const scopeLabel = (t: TFunction, scope: string) => {
  const [area, access] = scope.split(':')

  return t(`oauth.scopes.areas.${area}`, { defaultValue: '' })
    ? `${t(`oauth.scopes.areas.${area}`)} – ${t(`oauth.scopes.access.${access}`, { defaultValue: access })}`
    : scope
}
